export default __webpack_public_path__ + "static/media/quotation-footer-hd.cd4fd33e.png";